import React, { useState} from 'react';
import { Grid } from '@mui/material';
import CssBaseline from '@mui/material/CssBaseline';
import SideNav from 'components/sideNav/SideNav';
import { useStyles } from './LayoutStyle';
import Header from 'components/header/Header';
import { drawerWidthEnum } from 'utils/enumObject';

const Layout = ({ children }) => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const [drawerWidth, setDrawerWidth] = useState(drawerWidthEnum?.maxWidth);
  const [onlyMobile, setOnlyMobile] = useState(false);

  const handleDrawerOpen = () => {
    setOpen(!open);
    if(open){
      setDrawerWidth(drawerWidthEnum?.maxWidth)
    }else{
      setDrawerWidth(drawerWidthEnum?.minWidth)
    }
  };

  const handleDrawerClose = () => {
    setOpen(false);
    setDrawerWidth(drawerWidthEnum?.minWidth)
  };

  const handelOnMobile = () => {
    setOnlyMobile(!onlyMobile)
    setDrawerWidth(drawerWidthEnum?.maxWidth)
  }

  return (
    <Grid className={classes.root}>
      <CssBaseline />

      <Grid container item className={classes.mainBody}>

        <SideNav
          open={open}
          onlyMobile={onlyMobile}
          onMobileOpen={handelOnMobile}
          handleDrawerClose={handleDrawerClose}
          handleDrawerOpen={handleDrawerOpen}
        />
        <Grid item className={classes.content} sx={{
            flexGrow: 1,
            width: { sm: `calc(100% - ${drawerWidth}px)` },
            ml: { sm: `${drawerWidth}px` },
          }}>
            <Header handelOnlyOnMobile={handelOnMobile}/>
            <div className='layoutChildren'>
              {children}
            </div>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default Layout;